export const metricsOverviewDemoData = {
  totals: {
    classes: 3,
    assignments: 5,
    students: 6,
    teachers: 1,
  },
  averageScoreChart: {
    labels: ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb"],
    datasets: [{ label: "Average Score", data: [66, 67, 69, 71, 72, 72] }],
  },
  averageAIDetectionChart: {
    labels: ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb"],
    datasets: [{ label: "Average AI Detection", data: [10, 12, 8, 14, 11, 9] }],
  },
  classes: [
    {
      id: 1,
      name: "9th Grade A",
      source: "google_classroom",
      avgScore: 80,
      trend: [70, 72, 74, 77, 79, 80],
      students: 2,
      needSupport: 0,
    },
    {
      id: 2,
      name: "9th Grade B",
      source: "google_classroom",
      avgScore: 70,
      trend: [68, 67, 69, 70, 70, 70],
      students: 2,
      needSupport: 1,
    },
    {
      id: 3,
      name: "9th Grade C",
      source: "essaygrader",
      avgScore: 67,
      trend: [70, 69, 68, 68, 67, 67],
      students: 2,
      needSupport: 1,
    },
  ],
};

export const metricsOverviewEmptyData = {
  totals: {
    classes: 0,
    assignments: 0,
    students: 0,
    teachers: 0,
  },
  averageScoreChart: {
    labels: [],
    datasets: [{ label: "Average Score", data: [] }],
  },
  averageAIDetectionChart: {
    labels: [],
    datasets: [{ label: "Average AI Detection", data: [] }],
  },
  classes: [],
};
